import React from "react";
import "./Newsroom.css";

const articles = [
  {
    title: "Jortel Australia acquires Arid Land Communications",
    date: "April 2025",
    body: `Jortel accelerated its national operations through the acquisition of Arid Land Communications, a regional telecommunications provider based in Port Augusta, SA. Arid Land's expertise in building and maintaining mobile and broadband infrastructure for major carriers including Telstra, Optus, Vodafone and NBN, along with its experience supporting other telcos, public schools, and government networks, complements Jortel's vision of creating a unified, nationwide service environment that adds valuable capability to Jortel's growing services portfolio.`,
  },
  {
    title: "Jortel Australia acquires Applied VoIP",
    date: "November 2023",
    body: `The acquisition of Applied VoIP by Jortel Australia reflects a deliberate investment in the future of telecom service delivery. The deal brings additional operational maturity to Jortel's ecosystem. With Applied VoIP now part of Jortel, the company is positioned to deliver a more seamless, consistent, and scalable telecommunications experience across Australia.`,
  },
  {
    title: "Jortel Australia acquires OzBill Solutions",
    date: "July 2023",
    body: `Jortel expanded its nationwide telecommunications capability through the acquisition of OzBill Solutions. The integration strengthened Jortel's operational reach and added depth to its service portfolio, combining OzBill's established telecom expertise with Jortel's growing national customer portfolio. The acquisition reinforced Jortel's commitment to delivering reliable, modern connectivity solutions across Australia.`,
  },
  {
    title: "Jortel Australia acquires telecommunication customer base of Diamond IT",
    date: "August 2022",
    body: `Jortel advanced its national growth plan by acquiring the telecommunications customer base of Diamond IT. By focusing solely on the migration of active contracts and support responsibilities, Jortel avoided the intricacies of a full merger and delivered a simple, customer centric transition. The strategic move provided former Diamond IT customers with stronger network performance and access to Jortel's enhanced national support channels.`,
  },
];

export default function Newsroom(): JSX.Element {
  return (
    <main className="newsroom-page">
      <section className="newsroom-hero">
        <div className="newsroom-hero-inner">
          <span className="pill">Newsroom</span>
          <h1>Latest from Jortel</h1>
          <p>Key milestones and acquisitions shaping our national network.</p>
        </div>
      </section>

      <section className="newsroom-list">
        {articles.map((a) => (
          <article className="news-card" key={a.title}>
            <div className="news-dot" />
            <div className="news-card-inner">
              <div className="news-top">
                <span className="news-tag">Acquisition</span>
                <span className="news-date">{a.date}</span>
              </div>
              <h3>{a.title}</h3>
              <p>{a.body}</p>
            </div>
          </article>
        ))}
      </section>
    </main>
  );
}
